import { createDeepEqualSelector } from '../../utils/selectors';

import { selectAuth } from '../selectors';

export const selectUserSignup = createDeepEqualSelector(selectAuth, (auth) => auth.signup);
